import { createGlobalStyle } from "styled-components";

type CustomThemeProps = {
  font?: string | null;
  buttonColor?: string | null;
  buttonTextColor?: string | null;
  buttonBorderRadius?: string | null;
  selectionButtonBorderRadius?: string | null;
  modalBorderRadius?: string | null;
};

const CustomGlobalStyle = createGlobalStyle<CustomThemeProps>`
  * {
  font-family: ${({ font }) => font || ""};
  }

  [id*="custom-button"], [id*="custom-button_inverted"], [id*="custom-button_inverted-bordered"], [id*="custom-button"]:enabled:hover, [id*="custom-button"]:focus {
    background: ${({ buttonColor }) => (buttonColor ? `#${buttonColor}` : "#000000")} !important;
    color: ${({ buttonTextColor }) =>
      buttonTextColor ? `#${buttonTextColor}` : "#FFFFFF"} !important;
    ${({ buttonBorderRadius }) =>
      buttonBorderRadius ? `border-radius: ${buttonBorderRadius} !important;` : ""}
    transition: color 150ms cubic-bezier(0.4, 0, 0.2, 1),
                background-color 150ms cubic-bezier(0.4, 0, 0.2, 1),
                border-color 150ms cubic-bezier(0.4, 0, 0.2, 1),
                text-decoration-color 150ms cubic-bezier(0.4, 0, 0.2, 1),
                fill 150ms cubic-bezier(0.4, 0, 0.2, 1),
                stroke 150ms cubic-bezier(0.4, 0, 0.2, 1),
                opacity 150ms cubic-bezier(0.4, 0, 0.2, 1),
                box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1),
                transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
                filter 150ms cubic-bezier(0.4, 0, 0.2, 1),
                backdrop-filter 150ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  [id*="custom-button"]:enabled:hover, [id*="custom-button_inverted"]:enabled:hover, [id*="custom-button_inverted-bordered"]:enabled:hover, [id*="custom-button"]:focus, [id*="custom-button_inverted"]:focus, [id*="custom-button_inverted-bordered"]:focus  {
    opacity: 0.5;
  }

  [id*="custom-button_inverted"], [id*="custom-button_inverted-bordered"], [id*="custom-button_inverted"]:enabled:hover, [id*="custom-button_inverted-bordered"]:enabled:hover, [id*="custom-button_inverted"]:focus, [id*="custom-button_inverted-bordered"]:focus {
    background: ${({ buttonTextColor }) =>
      buttonTextColor ? `#${buttonTextColor}` : "#FFFFFF"} !important;
    color: ${({ buttonColor }) => (buttonColor ? `#${buttonColor}` : "#000000")} !important;
  }

  [id*="custom-button_inverted-bordered"] {
    border-style: solid !important;
    border-width: 1px !important;
    border-color: ${({ buttonColor }) => (buttonColor ? `#${buttonColor}` : "#000000")} !important;
  }

  ${({ selectionButtonBorderRadius }) =>
    selectionButtonBorderRadius
      ? `[id*="custom-selection-button"] { border-radius: ${selectionButtonBorderRadius} !important; }`
      : ""}

  ${({ modalBorderRadius }) =>
    modalBorderRadius
      ? `[id*="custom-modal-container"] { border-radius: ${modalBorderRadius} !important; }`
      : ""}
`;

export default CustomGlobalStyle;
